export enum StylePages {
  reports = 'reports',
  dashboards = 'dashboards',
}

const style = {
  [StylePages.reports]: {
    entityBackgroundColor: 'var(--color-background-page)',
    fieldHoverBackgroundColor: 'var(--color-surface-list-hover)',
  },
  [StylePages.dashboards]: {
    entityBackgroundColor: 'var(--color-surface-base-primary)',
    fieldHoverBackgroundColor: 'var(--color-surface-list-hover)',
  },
};
export default (page: string) => style[page];
